<template>
    <span
        class="inline-flex max-w-[9rem] items-center gap-1 rounded-full border border-[#FF421E]/20 bg-[#FF421E]/10 px-2 py-0.5 text-[11px] font-medium text-[#FF421E]"
    >
        <span class="truncate">{{ label }}</span>
        <button
            v-if="removable"
            type="button"
            class="shrink-0 cursor-pointer text-[#FF421E]/70 transition hover:text-[#FF421E]"
            :aria-label="removeLabel"
            @click="$emit('remove')"
        >
            <XMarkIcon class="h-3 w-3" />
        </button>
    </span>
</template>

<script lang="ts" setup>
import { XMarkIcon } from "@heroicons/vue/24/outline";

withDefaults(
    defineProps<{
        label: string;
        removable?: boolean;
        removeLabel?: string;
    }>(),
    { removable: false, removeLabel: "" },
);

defineEmits<{
    (event: "remove"): void;
}>();
</script>
